import React, { useRef, useState, useEffect } from "react";
import CssTransition from "../../../../component/layout/css-transition";
import { Controller, useForm } from "react-hook-form";
import "../../../../css/theme.css";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import InputField from "../../../../component/input-field";
import { checkBlankSpace, checkNumber } from "../../../../utils";
import Select, { components } from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTimeZoneForOnboarding } from "../../../../redux/actions/onboarding";
import {
  RESET_SAVE_TEMPORARY_DATA,
  SAVE_TEMPORARY_DATA,
} from "../../../../redux/constants";

// Importing sweet alert modal pop-up
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../../component/modal-popup/customeModal";
import { getDepartment } from "../../../../redux/actions/department";
import { createUser } from "../../../../redux/actions/user";

const { MenuList } = components;

const schema = yup.object({
  first_name: yup
    .string()
    .required("First name is required.")
    // .matches(/^[\.a-zA-Z, ]*$/, "First name will only contain alphabets")
    .max(50, "First name have reached maximum limit of characters allowed."),
  last_name: yup
    .string()
    .required("Last name is required.")
    // .matches(/^[\.a-zA-Z, ]*$/, "Last name will only contain alphabets")
    .max(50, "Last name have reached maximum limit of characters allowed."),
  email: yup
    .string()
    .required("Email is required.")
    .email("Please enter a valid email address."),
  mobile: yup.string(),
  companyname: yup.string(),
  department: yup
    .array()
    .of(
      yup.object().shape({
        label: yup.string(),
        value: yup.string(),
      })
    )
    .required("Team is required.!")
    .min(1, "Team is required.!"),
  type: yup.string().required("Type is required.!"),
  time_zone_id: yup
    .object()
    .shape({
      label: yup.string(),
      value: yup.string(),
    })
    .required("Time Zone is required.!")
    .nullable(),
});

export default function AddUser({
  modalOpen,
  setModalOpen,
  update,
  setUpdate,
}) {
  const { saveData, tempPageName } = useSelector(
    (state) => state.tempWindowsData
  );

  const modalContent = useRef(null);
  const user = useSelector((state) => state.auth);
  const { companyNames } = useSelector((state) => state.user);
  const { departmentList } = useSelector((state) => state.department);
  const [department, setDepartment] = useState([]);
  const [companyList, setCompanyList] = useState(companyNames);
  const [companyName, setCompanyName] = useState({
    value: user.company.name,
    label: user.company.name,
  });
  const usertypes = [
    {
      value: "admin",
      label: "Admin",
    },
    {
      value: "user",
      label: "User",
    },
  ];
  const [usertype, setUserType] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { time_zone_for_onboarding } = useSelector((state) => state.onboarding);
  const [timeOptions, setTimeOptions] = useState([]);
  const [initialTimeZone, setInitialTimeZone] = useState({});
  const [loader, setLoader] = useState(false);

  // --------------- Multi Select Dropdown ------------------
  const [selectedOptions, setSelectedOptions] = useState([]);

  const { control, setValue, handleSubmit, reset, getValues } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  useEffect(() => {
    const list = [];
    companyNames?.forEach((item) => {
      if (item.companyname) {
        list.push({
          value: item.companyname,
          label: item.companyname,
        });
      }
    });
    setCompanyList(list);
  }, [companyNames]);

  useEffect(() => {
    const list = [];
    departmentList?.data?.forEach((item) =>
      list.push({
        label: item.name,
        value: item.id,
      })
    );
    setDepartment(list);
  }, [departmentList]);

  useEffect(() => {
    if (time_zone_for_onboarding.length > 0) {
      const arr = [];
      time_zone_for_onboarding.map((element) => {
        const obj = {
          label: element.timezone,
          value: element.timezone_id,
        };
        arr.push(obj);
      });
      setTimeOptions(arr);

      if (user.time_zone_id) {
        const userTimeZone = time_zone_for_onboarding.find(
          (item) => item.timezone_id === user.time_zone_id
        );

        if (userTimeZone) {
          setInitialTimeZone({
            label: userTimeZone.timezone,
            value: userTimeZone.timezone_id,
          });
        }
      } else {
        setInitialTimeZone(null);
        setValue("time_zone_id", null);
      }
    }
  }, [user.time_zone_id, time_zone_for_onboarding]);

  const defaultValues = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    department: [],
    mobile: "",
    companyname: "",
    type: "",
    time_zone_id: initialTimeZone,
  };

  useEffect(() => {
    if (tempPageName === "users") {
      setModalOpen(true);
      setValue("first_name", saveData?.first_name || "");
      setValue("last_name", saveData?.last_name || "");
      setValue("email", saveData?.email || "");
      setValue("mobile", saveData?.mobile || "");
      setSelectedOptions(saveData?.department || []);
      setValue("type", saveData?.type || "");
      setValue("time_zone_id", saveData?.time_zone_id || "");
    }
  }, [tempPageName, saveData]);

  useEffect(() => {
    if (modalOpen) {
      const request = {
        onError: () => {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content="Something went wrong. Please try again later."
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        },
      };

      dispatch(getTimeZoneForOnboarding(request));
      dispatch(getDepartment(() => {}));
    }
  }, [modalOpen]);

  // Funtion to Add User API
  const handleAddUser = async (data) => {
   
    setLoader(true);
    const request = {
      payload: data,
      onSuccess: () => {
        setUpdate(update + 1);
        setModalOpen(false);
        setLoader(false);
        reset(defaultValues);
        setSelectedOptions([]);
        setUserType("");
        if (tempPageName === "users") {
          dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
        }
      },
      onError: (error) => {
        setModalOpen(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={
                error.message === "Duplicate entry"
                  ? "User already exist with this name. try using another name."
                  : error.message
              }
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(createUser(request));
  };

  const onSubmit = (data) => {
    const firstname = data.first_name
      ? checkBlankSpace(data.first_name)
      : false;
    const lastname = data.last_name ? checkBlankSpace(data.last_name) : false;
    const mobile = data.mobile ? checkNumber(data.mobile) : false;
    if (firstname || lastname || mobile) {
      return;
    }

    handleAddUser({
      type: data.type,
      department: data.department,
      mobile: data.mobile,
      email: data.email,
      last_name: data.last_name,
      first_name: data.first_name,
      companyname: companyName.value,
      role: "user",
      time_zone_id: data.time_zone_id?.value ?? initialTimeZone.value,
    });
  };

  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const MoreSelectedBadge = ({ items }) => {
    const style = {
      marginLeft: "auto",
      background: "#d4eefa",
      borderRadius: "4px",
      fontFamily: "Open Sans",
      fontSize: "11px",
      padding: "3px",
    };

    const title = items.join(", ");
    const length = items.length;
    const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

    return (
      <div style={style} title={title}>
        {label}
      </div>
    );
  };

  const MultiValue = ({ index, getValue, ...props }) => {
    const maxToShow = 2;
    const overflow = getValue()
      .slice(maxToShow)
      .map((x) => x.label);

    return index < maxToShow ? (
      <components.MultiValue {...props} />
    ) : index === maxToShow ? (
      <MoreSelectedBadge items={overflow} />
    ) : null;
  };

  const handleNavigate = () => {
    const payload = {
      path: location.pathname,
      tempPageName: "users",
      saveData: getValues(),
    };
    dispatch({ type: SAVE_TEMPORARY_DATA, payload });
    navigate("/departments", { state: true });
  };

  const CustomMenuList = ({ children, ...props }) => (
    <MenuList {...props}>
      {children}
      <div
        className="menu-list"
        onClick={(e) => {
          e.stopPropagation();
          handleNavigate();
        }}
      >
        <i
          class="fa-solid fa-plus fa-xs"
          style={{ paddingRight: "2px", paddingTop: "2px" }}
        ></i>
        Create New Team
      </div>
    </MenuList>
  );

  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white overflow-auto max-w-2xl w-full rounded-2xl shadow-lg flex flex-col"
        >
          <div class="py-8 px-6 ">
            {/* Search form */}
            <h3 class="mb-6 text-xl font-medium text-gray-900 flex justify-center">
              New User
            </h3>
            <form class="w-full" onSubmit={handleSubmit(onSubmit)}>
              <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <Controller
                    name="first_name"
                    defaultValue={defaultValues.first_name}
                    control={control}
                    render={({ field: { value, ...field }, formState }) => (
                      <div>
                        <InputField
                          {...field}
                          value={value}
                          type="text"
                          label="First Name"
                          placeholder="Enter First Name"
                          error={
                            Boolean(formState.errors?.first_name)
                              ? formState.errors?.first_name.message
                              : null
                          }
                          inputrequired={true}
                        />
                        {value.length > 0 &&
                        checkBlankSpace(value) &&
                        Object.keys(formState.errors).length === 0 ? (
                          <div className="text-xs text-rose-600 pt-1 pl-1">
                            Blank space is not allowed in first name.
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  />
                </div>
                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <Controller
                    name="last_name"
                    defaultValue={defaultValues.last_name}
                    control={control}
                    render={({ field: { value, ...field }, formState }) => (
                      <div>
                        <InputField
                          {...field}
                          value={value}
                          type="text"
                          label="Last Name"
                          placeholder="Enter Last Name"
                          error={
                            Boolean(formState.errors?.last_name)
                              ? formState.errors?.last_name.message
                              : null
                          }
                          inputrequired={true}
                        />
                        {value.length > 0 &&
                        checkBlankSpace(value) &&
                        Object.keys(formState.errors).length === 0 ? (
                          <div className="text-xs text-rose-600 pt-1 pl-1">
                            Blank space is not allowed in last name.
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  />
                </div>
              </div>
              <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <Controller
                    name="email"
                    defaultValue={defaultValues.email}
                    control={control}
                    render={({ field, formState }) => (
                      <div>
                        <InputField
                          {...field}
                          type="text"
                          label="Email ID"
                          placeholder="Enter Email ID"
                          error={
                            Boolean(formState.errors?.email)
                              ? formState.errors?.email.message
                              : null
                          }
                          inputrequired={true}
                        />
                      </div>
                    )}
                  />
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <Controller
                    name="mobile"
                    defaultValue={defaultValues.mobile}
                    control={control}
                    render={({ field: { value, ...field }, formState }) => (
                      <div>
                        <InputField
                          {...field}
                          value={value}
                          type="text"
                          label="Phone Number"
                          placeholder="Enter Phone Number"
                          error={
                            Boolean(formState.errors?.mobile)
                              ? formState.errors?.mobile.message
                              : null
                          }
                        />
                        {value.length > 0 && checkNumber(value) ? (
                          <div className="text-xs text-rose-600 pt-1 pl-1">
                            Mobile no. should be valid. It contains min 6 and
                            max 12 digits
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  />
                </div>
              </div>
              <div class="flex flex-wrap -mx-3 mb-8">
                <div class="w-full md:w-1/2 px-3">
                  <Controller
                    name="department"
                    defaultValue={defaultValues.department}
                    control={control}
                    render={({ field, formState }) => (
                      <div>
                        <label
                          for="department"
                          class="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Team<span className="text-rose-500">*</span>
                        </label>
                        <Select
                          isMulti
                          options={department}
                          className="basic-multi-select unresetText"
                          classNamePrefix="select"
                          isClearable={true}
                          placeholder="Select Team"
                          closeMenuOnSelect={false}
                          onChange={(e) => {
                            setValue("department", e);
                          }}
                          value={field.value}
                          menuPortalTarget={document.body}
                          menuIsOpen={isFocused}
                          onFocus={handleFocus}
                          onBlur={handleBlur}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "black",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              display: "none",
                            }),
                          }}
                          components={{
                            MultiValue,
                            MenuList: CustomMenuList,
                          }}
                          hideSelectedOptions={false}
                        />
                        {field.value.length === 0 &&
                          formState.errors?.department && (
                            <div className="text-xs text-rose-600 pt-1 pl-1">
                              {formState.errors?.department?.message}
                            </div>
                          )}
                      </div>
                    )}
                  />
                </div>
                <div className="w-full md:w-1/2 px-3 flex justify-center space-x-3">
                  <div class="w-full md:w-1/2">
                    <Controller
                      name="time_zone_id"
                      control={control}
                      render={({ field, formState }) => (
                        <div>
                          <label
                            for="country"
                            class="block mb-2 text-sm font-medium text-gray-900"
                          >
                            Time Zone
                            <span className="text-rose-500">*</span>
                          </label>
                          <Select
                            name="time_zone_id"
                            className="unresetText text-left"
                            placeholder="Select Zone"
                            menuPortalTarget={document.body}
                            menuPlacement="top"
                            options={timeOptions}
                            value={field.value ?? initialTimeZone}
                            onChange={(val) => {
                              setValue("time_zone_id", val);
                            }}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                            classNames={{
                              control: (style) => {
                                return `!border !shadow-sm ${
                                  style.isFocused
                                    ? "!border-[--bg-color-300]/50"
                                    : "!border-slate-200 hover:!border-gray-300"
                                }`;
                              },
                              container: (style) => {
                                return "!h-[37.5px] !font-inter !text-sm";
                              },
                              menuList: (style) => {
                                return `!max-h-[200px]`;
                              },
                            }}
                          />
                          {field.value === null &&
                            formState.errors?.time_zone_id && (
                              <div className="text-xs text-rose-600 pt-1 pl-1">
                                {formState.errors?.time_zone_id?.message}
                              </div>
                            )}
                        </div>
                      )}
                    />
                  </div>
                  <div className="w-full md:w-1/2">
                    <Controller
                      name="type"
                      defaultValue={defaultValues.type}
                      control={control}
                      render={({ field, formState }) => (
                        <div>
                          <label
                            for="first_name"
                            class="block mb-2 text-sm font-medium text-gray-900 "
                          >
                            User Type
                            <span className="text-rose-500">*</span>
                          </label>
                          {/* <select
                          {...field}
                          id="card-state"
                          name="type"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        >
                          <option value="">Select User Type</option>
                          <option value="admin">Admin</option>
                          <option value="user">User</option>
                        </select> */}
                          <Select
                            className="basic-single text-sm unresetText"
                            classNames={{
                              control: (style) => {
                                return `!border !shadow-sm ${
                                  style.isFocused
                                    ? "!border-[--bg-color-300]/50"
                                    : "!border-slate-200 hover:!border-gray-300"
                                }`;
                              },
                              container: (style) => {
                                return "!h-[37.5px] !font-inter !text-sm";
                              },
                              menuList: (style) => {
                                return `!max-h-[200px]`;
                              },
                            }}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                            classNamePrefix="select"
                            value={usertype}
                            placeholder="Select Type"
                            options={usertypes}
                            onChange={(e) => {
                              setUserType(e);
                              setValue("type", e.value);
                            }}
                          />
                          {field.value === "" && formState.errors?.type && (
                            <div className="text-xs text-rose-600 pt-1 pl-1">
                              {formState.errors?.type?.message}
                            </div>
                          )}
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>

              <div class="flex nowrap">
                <button
                  className=" w-1/2 btn bg-slate-100 border-slate-200 hover:border-slate-300 text-slate-600 mr-2"
                  type="button"
                  disabled={loader}
                  onClick={() => {
                    setModalOpen(false);
                    setSelectedOptions([]);
                    setUserType("");
                    reset(defaultValues);
                  }}
                >
                  Cancel
                </button>
                <button
                  className={`w-1/2 btn ${
                    loader ? "!bg-[--bg-color-400]" : "!bg-[--bg-color-500]"
                  } text-white hover:!bg-[--bg-color-600] ml-2`}
                  type="Submit"
                  disabled={loader}
                >
                  {loader ? (
                    <span className="ml-2">
                      <svg
                        className="animate-spin w-4 h-4 fill-current shrink-0"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                      </svg>
                    </span>
                  ) : (
                    "Create"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </CssTransition>
    </>
  );
}
